import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { useActivation } from '@/hooks/view-model-hooks'
import { ProPayoutsView } from '@/features/payouts/pro/components/ProPayoutsView'
import { PayoutSummary } from '@/features/payouts/pro/components/PayoutSummary'
import { ProHistoricalTransactionsTableContainer } from '@/features/payouts/pro/components/ProHistoricalTransactionsTable/ProHistoricalTransactionsTableContainer'

export default observer(function ProPayoutsViewContainer() {
  const { payouts } = useFeatures((r) => ({ payouts: r.payouts.internal() }))
  const vm = payouts.proPayoutsViewModel ?? undefined
  useActivation(vm)
  if (!vm) {
    return null
  }

  return (
    <ProPayoutsView
      transactionsCount={vm.transactionsCount}
      summary={
        <PayoutSummary
          isPending={vm.fetchSummary.pending}
          earningsYearToDate={vm.summary.earningsYearToDate}
          pendingEarnings={vm.summary.pendingEarnings}
          lifetimeEarnings={vm.summary.lifetimeEarnings}
        />
      }
      transactionsTable={<ProHistoricalTransactionsTableContainer vm={vm} />}
    />
  )
})
